import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISendTestAgendasPayload {
    participants?: any
    companies?: any
    meetingDate?: string
    status?: string[]
    meetingType?: string[]
    email: string
    timeShift: any
    sagaCB?: {
        onSuccess: any
        onError: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const sendTestAgendasSlice = createSlice({
    name: 'reporting/send-test-agendas',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISendTestAgendasPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const sendTestAgendasActions = sendTestAgendasSlice.actions
export default sendTestAgendasSlice.reducer
